import { ReportTemplatesDashboardTable } from "modules/ReportTemplatesDashboard/components";
import "modules/ReportTemplatesDashboard/ReportTemplatesDashboard.scss";

export const ReportTemplatesDashboard = () => (
  <div className="ReportTemplatesDashboard">
    <ReportTemplatesDashboardTable />
  </div>
);
